import TransfigureNavigation from './lib/TransfigureNavigation.js';

export default TransfigureNavigation;
